// extracted by mini-css-extract-plugin
module.exports = {"Formatter":"Formatter_Formatter_3-rB-","WarningIcon":"Formatter_WarningIcon_2pehO"};